"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _DiscountPill = _interopRequireDefault(require("./DiscountPill"));
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HeaderWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    display: flex;
    justify-content: space-between;
    flex-direction: ${props.breakPoints.sm ? 'column' : 'row'};
  `);
const PlanNameWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-bottom: ${props.breakPoints.sm ? '16px' : '0px'};
  `);
const PriceWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    align-items: ${props.breakPoints.sm ? 'flex-start' : 'flex-end'};
    flex-grow: 1;
  `);
const PillAndIconWrapper = _styledComponents.default.div`
  display: flex;
  align-items: center;
`;
const RightStackMainTextWrapper = _styledComponents.default.div`
  display: flex;
  align-items: flex-end;
`;
const EntelPlanCardHeader = _ref => {
  let {
    leftStack,
    rightStack
  } = _ref;
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  return /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(PlanNameWrapper, {
    "data-testid": `product-name-${leftStack === null || leftStack === void 0 ? void 0 : leftStack.planIndex}`,
    breakPoints: breakPoints
  }, (leftStack === null || leftStack === void 0 ? void 0 : leftStack.topText) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: leftStack.topText,
    size: breakPoints.sm ? 2 : 1,
    weight: 3,
    noMargin: true,
    dataAttributes: {
      'data-testid': 'plan-topText'
    }
  }), (leftStack === null || leftStack === void 0 ? void 0 : leftStack.mainText) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: leftStack.mainText,
    size: 2,
    weight: breakPoints.sm ? 2 : 3,
    noMargin: true,
    dataAttributes: {
      'data-testid': 'plan-mainText'
    }
  }), (leftStack === null || leftStack === void 0 ? void 0 : leftStack.bottomText) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: leftStack.bottomText,
    size: 2,
    weight: 3,
    noMargin: true,
    dataAttributes: {
      'data-testid': 'plan-bottomText'
    }
  })), /*#__PURE__*/_react.default.createElement(PriceWrapper, {
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(PillAndIconWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 1
    }
  }, (rightStack === null || rightStack === void 0 ? void 0 : rightStack.pillText) && /*#__PURE__*/_react.default.createElement(_DiscountPill.default, {
    testId: `discount-amount-${leftStack === null || leftStack === void 0 ? void 0 : leftStack.planIndex}`,
    text: rightStack.pillText
  })), (rightStack === null || rightStack === void 0 ? void 0 : rightStack.show5g) && /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    group: "midLight",
    iconWidth: "32px",
    iconHeight: "32px",
    size: 1,
    src: {
      sm: '/assets/ws10/icons/entel/5G.svg',
      md: '/assets/ws10/icons/entel/5G.svg',
      lg: '/assets/ws10/icons/entel/5G.svg'
    },
    testId: `5G-icon-${leftStack === null || leftStack === void 0 ? void 0 : leftStack.planIndex}`
  })), (rightStack === null || rightStack === void 0 ? void 0 : rightStack.mainText) && /*#__PURE__*/_react.default.createElement(RightStackMainTextWrapper, {
    "data-test-id": `price-after-discount-${leftStack === null || leftStack === void 0 ? void 0 : leftStack.planIndex}`
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: rightStack.mainText.large,
    size: breakPoints.sm ? 3 : 2,
    weight: 3,
    appearance: "secondary",
    noMargin: true,
    dataAttributes: {
      'data-testid': 'right-stack-lg-main-text'
    }
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: rightStack.mainText.normal,
    size: breakPoints.sm ? 3 : 2,
    weight: breakPoints.sm ? 2 : 3,
    appearance: "secondary",
    noMargin: true,
    dataAttributes: {
      'data-testid': 'right-stack-normal-main-text'
    }
  })), (rightStack === null || rightStack === void 0 ? void 0 : rightStack.bottomText) && (rightStack === null || rightStack === void 0 ? void 0 : rightStack.showBottomText) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-testid': `price-value-${leftStack === null || leftStack === void 0 ? void 0 : leftStack.planIndex}`
    },
    size: breakPoints.sm ? 1 : 2,
    noMargin: true
  }, rightStack.bottomText), (rightStack === null || rightStack === void 0 ? void 0 : rightStack.blueText) && (rightStack === null || rightStack === void 0 ? void 0 : rightStack.showSecondPrice) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    weight: 3,
    appearance: "secondary",
    size: 1,
    text: rightStack.blueText,
    dataAttributes: {
      'data-testid': 'right-stack-blue-text'
    }
  })));
};
var _default = EntelPlanCardHeader;
exports.default = _default;